var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30228 1.75658L8.36019 1.68287C8.39286 1.61046 8.57088 1.47374 8.81381 1.50383L9.01576 1.59366C9.11295 1.64117 9.14628 1.67241 9.18169 1.7383L9.22024 1.81764L9.25065 1.92388L9.25792 2.00159L9.26501 6.63201H11.223L11.2464 6.62884C11.3025 6.62472 11.3591 6.62884 11.4142 6.64122L11.4957 6.66598L11.6203 6.71418L11.7043 6.81809C11.8416 6.98805 11.8691 7.21613 11.7867 7.40934L8.40793 14.1711L8.36373 14.2434L8.30583 14.3172C8.27316 14.3896 8.09513 14.5263 7.8522 14.4962L7.65026 14.4064C7.55306 14.3589 7.51974 14.3276 7.48433 14.2617L7.44578 14.1824L7.41536 14.0761L7.4081 13.9984L7.40634 9.36734H5.44234L5.41965 9.37118C5.36354 9.3753 5.30696 9.37118 5.25178 9.3588L5.17027 9.33404L5.04569 9.28584L4.96174 9.18193C4.7901 8.96948 4.7901 8.66622 4.96174 8.45376L8.25809 1.82896L8.30228 1.75658ZM8.26577 7.0133L8.26167 4.05868L6.10967 8.36734L7.78619 8.36772C8.10361 8.36772 8.36679 8.60606 8.40277 8.91494L8.40696 8.9874L8.40634 11.9353L10.5557 7.63201L8.88654 7.6323C8.56912 7.6323 8.30593 7.39396 8.26996 7.08562L8.26577 7.0133Z",
    fill: "#0F67BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/Lightning.d6ea2a702ea6fd9a630a4df074c4cce1.svg";
export { ForwardRef as ReactComponent };